import { postData } from "./Http/api";

const LOCAL_STORAGE_KEY = 'lastErrors';

const saveErrorLocally = (errorPayload) => {
    try {
        const existing = localStorage.getItem(LOCAL_STORAGE_KEY);
        const errors = existing ? JSON.parse(existing) : [];
        errors.push(errorPayload);
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(errors));
    } catch {
        // Ignorar errores de localStorage para no romper la app
    }
};

const sendStoredErrors = async () => {
    try {
        const existing = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (!existing) return;
        if (existing.length === 0) return;
        const errors = JSON.parse(existing);

        await postData("ErrorLogDtoAlta", errors);

        localStorage.removeItem(LOCAL_STORAGE_KEY);
    } catch (e) {
        console.warn('[sendStoredErrors] No se pudieron enviar todos los errores', e);
    }
};

export const logError = async (error) => {
    const payload = [{
        message: error?.message || String(error),
        stack: error?.stack || '',
        url: error?.endpoint || window.location.href,
        userAgent: navigator.userAgent,
        request: JSON.stringify(error?.request || '') ,
        response:JSON.stringify(error?.response || ''),
        Usuario: localStorage.getItem('userlogueado'),
        fecha: new Date().toISOString()
    }];

    try {
        await postData("ErrorLogDtoAlta", payload);
    } catch (e) {
        console.warn('[logError] No se pudo registrar el error en el backend. Guardando localmente.');
        saveErrorLocally(payload[0]);
    }
};

export const trySendStoredErrors = async () => {
    await sendStoredErrors();
};
